export class LRUCache<KeyType, ValueType> {
  private _size: number;

  private readonly cache: Map<KeyType, ValueType>;

  constructor(size: number) {
    this._size = size;
    this.cache = new Map<KeyType, ValueType>();
  }

  has(key: KeyType) {
    return this.cache.has(key);
  }

  get(key: KeyType) {
    const item = this.cache.get(key);
    if (item) {
      this.cache.delete(key);
      this.cache.set(key, item);
    }
    return item;
  }

  set size(value: number) {
    this._size = value;
    while (this.cache.size && value <= this.cache.size) {
      this.cache.delete(this.first());
    }
  }

  get size() {
    return this._size;
  }

  get count() {
    return this.cache.size;
  }

  set(key: KeyType, val: ValueType) {
    if (this.cache.has(key)) {
      this.cache.delete(key);
    } else if (this.cache.size && this.cache.size === this._size) {
      this.cache.delete(this.first());
    }
    if (this.cache.size < this._size) {
      this.cache.set(key, val);
    }
  }

  first() {
    return this.cache.keys().next().value;
  }

  clear() {
    this.cache.clear();
  }

  delete(key: KeyType) {
    this.cache.delete(key);
  }

  keys() {
    return this.cache.keys();
  }
}
